const GTM_ENABLED = process.env.REACT_APP_GTM_ENABLED === 'true';
const GTM_LOGGING = process.env.REACT_APP_GTM_LOGGING === 'true';

let state = {
  brand: undefined,
  campaignID: 'unspecified',
  environment: 'on-site',
  event: undefined,
  language: undefined,
  locale: undefined,
  propertyName: undefined,
  pageID: undefined,
  pageTitle: undefined,
  pageViewID: undefined,
  mobileID: 'unspecified',
  siteType: 'website',
  ssidCookie: undefined, // SiteSpect
  ssscCookie: undefined, // SiteSpect
  userID: undefined,
  virtPath: undefined,
};

const getCookie = (name) => {
  const cookieMap = {};
  document.cookie.split(';').forEach((cookie) => {
    const [key, value] = cookie.split('=');
    cookieMap[key.trim()] = value;
  });

  return cookieMap[name];
};

const getCookies = () => ({
  ssidCookie: getCookie('SSID'),
  ssscCookie: getCookie('SSSC'),
});

const getState = () => state;

const setState = (props) =>
  (state = {
    ...state,
    ...props,
  });

const log = (data) => console.log('--- Analytics Data ---', data);

const push = (data) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};

const pushData = (data) => {
  if (GTM_LOGGING) log(data);
  if (GTM_ENABLED) push(data);
};

export { getCookies, pushData, getState, setState };
